import { snakeToCamelObj } from '@/common/converter/utils/snake-to-camel-obj'

export const normalizeAdditionalInformation = (rawData) => {
  return {
    broadDt: rawData?.broad_dt ?? '',
    comingSoonDescription: rawData?.comingsoon_description ?? '',
    comingSoonSubtitle: rawData?.comingsoon_subtitle ?? '',
    infoUrl: rawData?.info_url ?? '',
    playUrl: rawData?.play_url ?? '',
  }
}

export const normalizeContextContent = (rawData) => {
  return {
    actors: rawData?.actors ?? [],
    contentImage: rawData?.content_image ?? '',
    orderTitle: rawData?.order_title ?? '',
    originTitle: rawData?.origin_title ?? '',
    originalReleaseDate: rawData?.original_release_date ?? '',
    originalReleaseYear: rawData?.original_release_year ?? '',
    ratings: rawData?.ratings ?? '',
    referId: rawData?.refer_id ?? '',
    runningTime: rawData?.running_time ?? '',
    synopsis: rawData?.synopsis ?? '',
    title: rawData?.title ?? '',
    titleWithOrder: rawData?.title_with_order ?? '',
    image: rawData?.image ?? '',
  }
}

export const normalizeContextPersonal = (rawData) => {
  return {
    likeStatus: rawData?.like_status ?? '',
    remainMinute: rawData?.remain_minute ?? '',
    targetAge: rawData?.targetage ?? '',
    viewDate: rawData?.view_date ?? '',
    viewRatio: rawData?.viewratio ?? '',
  }
}

export const normalizeContextProgram = (rawData) => {
  return {
    actors: rawData?.actors ?? [],
    fullColorContentLogoImage: rawData?.full_color_content_logo_image ?? '',
    referId: rawData?.refer_id ?? '',
    synopsis: rawData?.synopsis ?? '',
    title: rawData?.title ?? '',
    titleLogoImage: rawData?.title_logo_image ?? '',
    image: rawData?.image ?? '',
    verticalLogoYImage: rawData?.vertical_logo_y_image ?? '',
  }
}

export const normalizeContextSeries = (rawData) => {
  return {
    category: rawData?.category ?? '',
    fullColorContentLogoImage: rawData?.full_color_content_logo_image ?? '',
    horizontalLogoNImage: rawData?.horizontal_logo_n_image ?? '',
    horizontalLogoYImage: rawData?.horizontal_logo_y_image ?? '',
    orderTitle: rawData?.order_title ?? '',
    referId: rawData?.refer_id ?? '',
    singleColorContentLogoImage: rawData?.single_color_content_logo_image ?? '',
    verticalLogoYImage: rawData?.vertical_logo_y_image ?? '',
    title: rawData?.title ?? '',
    titleLogoImage: rawData?.title_logo_image ?? '',
  }
}

export const normalizeContextTag = (rawData) => {
  return {
    top: rawData?.top ?? [],
    brand: rawData?.brand ?? [],
    update: rawData?.update ?? [],
    event: rawData?.event ?? '',
    price: rawData?.price ?? '',
  }
}

export const normalizeContext = (rawData) => {
  return snakeToCamelObj(rawData)
}
